module.exports = __webpack_public_path__ + "static/sport/btn-reg-h5.60c00da.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/btn-reg-h5.gif
// module id = D3d7
// module chunks = 0